import React from 'react';
import { DowntimeIcon } from './DowntimeIcon';

export function DowntimeModal({ title, message, actionButton }) {
  return (
    <div className="as-Error-body">
      <h2 className="as-Error-title">{title}</h2>
      {
        <p
          className="as-Error-message"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      }

      <div className="as-Error-icon">
        <DowntimeIcon />
      </div>
      {actionButton.isVisible && (
        <a
          href={actionButton.href}
          className="as-Error-actionButton"
          target="_blank"
          rel="noopener noreferrer"
        >
          {actionButton.title}
        </a>
      )}
    </div>
  );
}
